module.exports = "/images/vendor/flag-icon-css/flags/1x1/cg.svg?8373836c83f0ae012b428ab2308e4352";